import React from 'react'
import './style.css'
import TextField from '../shared';


const StatusField = ({ id, value, statusMap }) => {
    return (
        <TextField value={value} className={`status-field-container ${statusMap[id].class}`} />
    );
};

export default StatusField;